export default __webpack_public_path__ + "777366661bbbe7b17a015ca92a9d00ae.svg";